import * as types from '../mutation-types'

const state = {
  windowSize: {
    height: 0,
    width: 0
  }
}

const actions = {
  ResizeWindow ({ dispatch, commit, state }, windowSize) {
    commit(types.WindowResize, windowSize)
  }
}

const mutations = {
  [types.WindowResize] (state, windowSize) {
    state.windowSize.height = windowSize.height
    state.windowSize.width = windowSize.width
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/window-resize.js